import { useEffect } from "react";

export function saveNavigationScroll(top = window.scrollY): void {
  window.history.replaceState({ ...window.history.state, scroll98: Number.isFinite(top) ? Math.max(0, Math.round(top)) : 0 }, "");
}
/** History retains location only, never a second draft or financial snapshot. */
export function useNavigationScroll(route: string): void {
  useEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previous; };
  }, []);
  useEffect(() => {
    const target = Number(window.history.state?.scroll98 ?? 0);
    let restoring = true;
    let stopped = false;
    const finish = () => { restoring = false; };
    const restore = () => {
      if (stopped || !restoring || window.location.hash !== route) return;
      window.scrollTo({ top: target, behavior: "instant" });
      if (document.documentElement.scrollHeight - window.innerHeight >= target && !document.querySelector("main [aria-busy=true]")) finish();
    };
    const stop = () => { stopped = true; finish(); };
    const observe = new MutationObserver(restore);
    observe.observe(document.body, { childList: true, subtree: true });
    const frame = requestAnimationFrame(restore);
    const timeout = window.setTimeout(finish, 4000);
    // popstate changes the URL/history entry before React removes this effect.
    // A departing short page can emit scroll=0 in that gap; it must not erase
    // the target page's saved scroll position.
    const record = () => { if (!restoring && window.location.hash === route) saveNavigationScroll(); };
    window.addEventListener("scroll", record, { passive: true });
    window.addEventListener("wheel", stop, { passive: true });
    window.addEventListener("touchmove", stop, { passive: true });
    return () => {
      cancelAnimationFrame(frame); clearTimeout(timeout); observe.disconnect();
      window.removeEventListener("scroll", record); window.removeEventListener("wheel", stop); window.removeEventListener("touchmove", stop);
    };
  }, [route]);
}
